import React from 'react';
import { Icon } from '@livable/saas-react-components';
import { Box, Tooltip } from '@mui/material';

/** As much of a note as a tooltip can show and still be read; the bill's details show all of it. */
const PREVIEW_LENGTH = 280;
const previewOf = note => note.length > PREVIEW_LENGTH ? "".concat(note.slice(0, PREVIEW_LENGTH).trimEnd(), "\u2026") : note;

/**
 * Says on the row that the customer wrote to our team with the bill (LB-6056), and what, on hover or focus. Plain
 * text from outside the company: handed to the tooltip as a string, which renders it as text.
 *
 * Reachable from the keyboard, and named for a screen reader: the label says there is a note, and the note itself is
 * the icon's description (describeChild), so it is read out with it.
 */
export const BillNoteIndicator = _ref => {
  let note = _ref.note,
    noteBy = _ref.noteBy;
  if (!note) return null;
  const title = "".concat(noteBy ? "Note from ".concat(noteBy) : 'Note', ": ").concat(previewOf(note));
  return /*#__PURE__*/React.createElement(Tooltip, {
    title: title,
    placement: "top",
    arrow: true,
    describeChild: true
  }, /*#__PURE__*/React.createElement(Box, {
    component: "span",
    role: "img",
    tabIndex: 0,
    "aria-label": "Has a note for our team",
    sx: {
      display: 'inline-flex',
      flexShrink: 0,
      borderRadius: 0.5,
      '&:focus-visible': {
        outline: '2px solid',
        outlineColor: 'primary.main',
        outlineOffset: 2
      }
    },
    'custom-attribute': 'bills-row-note'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "message",
    state: "info",
    fontSize: "small"
  })));
};